export default {
  NODE_ENV: process.env.NODE_ENV,
  PAPI_URL: process.env.PAPI_URL,
}
